import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const FallContrastIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M22 21C21.45 21 21 20.55 21 20V5H3V20C3 20.55 2.55 21 2 21C1.45 21 1 20.55 1 20V4C1 3.45 1.45 3 2 3H22C22.55 3 23 3.45 23 4V20C23 20.55 22.55 21 22 21Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

FallContrastIcon.displayName = 'FallContrastIcon';
